/**
 * Where the client looks for an arena. One constant, no discovery logic — the deployed
 * endpoint replaces the local one at build time when there is something to deploy to.
 */

/** Port `server/index.ts` listens on. */
const LOCAL_PORT = 2567;

/** Hostnames that mean "the battle server is the one `npm run localbattle` started". */
const LOCAL_HOSTS = ["localhost", "127.0.0.1", "[::1]", ""];

/**
 * The websocket endpoint for matchmaking.
 *
 * In development the page is served from :5185 by vite while the arena lives on
 * :2567, so the port cannot simply be inherited from `location`. Anywhere else, the
 * server is assumed to sit behind the same host — and on `https` the socket must be
 * `wss`, or the browser blocks it as mixed content.
 */
export function arenaEndpoint(): string {
    const { hostname, protocol, host } = window.location;

    if (LOCAL_HOSTS.includes(hostname)) return `ws://${hostname || "localhost"}:${LOCAL_PORT}`;

    return `${protocol === "https:" ? "wss" : "ws"}://${host}`;
}
